import type { ComponentProps } from "react"
import { EnterFullScreenIcon, ExitFullScreenIcon } from "@radix-ui/react-icons"
import cn from "@/v2-ui/utils/utils.cn"

export type ViewSheetExpandButtonProps = ComponentProps<"button"> & {
  isExpanded: boolean
}

function ViewSheetExpandButton(props: ViewSheetExpandButtonProps) {
  const { isExpanded, className, ...buttonProps } = props

  return (
    <button
      type="button"
      className={cn("view-sheet-expand-button", className)}
      {...buttonProps}
    >
      {isExpanded ? (
        <ExitFullScreenIcon className="view-sheet-expand-button-icon" />
      ) : (
        <EnterFullScreenIcon className="view-sheet-expand-button-icon" />
      )}
      <span className="sr-only">{isExpanded ? "Collapse" : "Expand"}</span>
    </button>
  )
}

export default ViewSheetExpandButton
